/* src/app/dialogs/document-editor/document-editor.component.css */
.mat-mdc-row,
.mat-mdc-header-row {
  padding: 0;
}
button.loadingbutton ::ng-deep .mdc-button__label {
  display: flex;
  align-items: center;
  justify-content: center;
}
button.loadingbutton:hover {
  cursor: default !important;
}
.bulk-update {
  font-size: 1.5em;
  cursor: pointer;
}
.msgbox {
  cursor: pointer;
  border-radius: 10px;
  text-align: center;
}
.mat-mdc-form-field .mat-mdc-form-field-suffix {
  padding-right: 8px !important;
  flex-shrink: 0;
}
.ordered-field .mat-mdc-form-field-infix {
  flex: 1 1 auto;
  min-width: 34px;
}
.ordered-field input {
  min-width: 30px;
}
.ordered-field .mat-mdc-form-field-suffix {
  flex: 0 1 auto;
  min-width: 0;
  max-width: 48px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
/*# sourceMappingURL=document-editor.component-YXWXOCFP.css.map */
